import { Resource, ResourceFile, ResourceState } from "@/types/resource";
import { create } from "zustand";

/**
 * Resource Store — mirrors projectStore.ts structure
 */

export const useResourceStore = create<ResourceState>((set) => ({
  resources: null,
  selectedResource: null,
  selectedResourceFiles: null,

  setResources: (resources: Resource[] | null) => set({ resources }),

  setSelectedResource: (id: number | null) =>
    set((state) => ({
      selectedResource:
        id === null
          ? null
          : state.resources?.find((resource) => resource.id === id) || null,
    })),

  setSelectedResourceFiles: (files: ResourceFile[] | null) =>
    set({ selectedResourceFiles: files }),
}));
